export enum AchievementType { // same as achievement_type enum in DB
  messageSent = 'messageSent',
  exerciseCompleted = 'exerciseCompleted',
  meetingAttended = 'meetingAttended'
}

export interface Achievement {
  id: string
  type: AchievementType,
  nickname: string,
  magnitude: number,
  imageUrl?: string
  title: string,
  body: string,
  isShareable: boolean,
  active: boolean
}

export interface AccountAchievement {
  id: string
  type: AchievementType,
  nickname: string,
  magnitude: number,
  imageUrl?: string
  title: string,
  body: string,
  isSeen: boolean,
  isShareable: boolean,
  dateCreated: string
}


export type AchievementCriteriaMeasures = Partial<Record<AchievementType, number>>
